import {ERoleAccessIsAny} from '../types/enum'

export const ACCESS_IS_ANY_COLORS_MAP: Record<ERoleAccessIsAny, string> = {
	[ERoleAccessIsAny.Custom]:' bg-success',
	[ERoleAccessIsAny.Any]: 'bg-danger',
	// [EOfferScopeStatus.closed]: 'bg-danger',
	// [EOfferScopeStatus.active]: 'bg-success',
	// [EOfferScopeStatus.paused]: 'bg-warning',
	// [EOfferScopeStatus.none]: 'bg-grey',
}